import { useCallback, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { UserForm } from '../../App/Types/UsersType';
import { getAllUsersByStatusAndRole } from '../Services/AdminService';
import UserManangementDetailsByStatusComponent from '../Components/UserManangementDetailsByStatusComponent';

function UserManagementDetailsPage() {
  const [adminData, setAdminData] = useState<UserForm[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string>('');

  const { status, role } = useParams();

  const fetchUsers = useCallback(async () => {
    try {
      setLoading(true);
      const response = await getAllUsersByStatusAndRole(status as string, role as string);
      if (response.success) {
        setAdminData(response.data);
        setError('');
      } else {
        setError(response.message || 'Could not retrieve target role data.');
      }
    } catch (err) {
      setError('An unexpected error occurred while loading the target roles.');
      console.error(err);
    } finally {
      setLoading(false);
    }
  }, [status, role]);

  useEffect(() => {
    fetchUsers();
  }, [fetchUsers]);

  if (loading) {
    return (
      <div className="min-h-screen bg-slate-950 p-8 text-sm font-semibold text-slate-400">
        Loading users...
      </div>
    );
  }

  if (error) {
    return (
      <div className="min-h-screen bg-slate-950 p-8 text-sm font-semibold text-rose-400">
        {error}
      </div>
    );
  }

  return (
    <UserManangementDetailsByStatusComponent
      data={adminData}
      onEditSubmit={() => {}}
      onDeleteConfirm={() => {}}
      onRegisterSubmit={() => {}}
      menuName="User Management"
      role={role}
      onChanged={fetchUsers}
    />
  );
}

export default UserManagementDetailsPage;
